import React from 'react';

export default () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 15H10.5V13.5H1.5V4.5H0V13.5C0 14.3273 0.67275 15 1.5 15Z" fill="currentColor" />
    <path d="M13.5 0H4.5C3.67275 0 3 0.67275 3 1.5V10.5C3 11.3273 3.67275 12 4.5 12H13.5C14.3273 12 15 11.3273 15 10.5V1.5C15 0.67275 14.3273 0 13.5 0ZM12 6.75H9.75V9H8.25V6.75H6V5.25H8.25V3H9.75V5.25H12V6.75Z" fill="currentColor" />
  </svg>

);
